import { withDisplayCurrency } from "@/features/display-currency/display-currency.utils";
import { useDisplayCurrency } from "@/features/display-currency/useDisplayCurrency";
import { QueryHookOptions, useQuery } from "@apollo/client";
import favoriteProductsQuery from "@whoppah/apollo/query/favoriteProducts.graphql";
import {
  FavoriteProductsQuery,
  FavoriteProductsQueryVariables,
} from "@whoppah/apollo/schema";

const useMyFavorites = (
  options?: QueryHookOptions<
    FavoriteProductsQuery,
    FavoriteProductsQueryVariables
  >
) => {
  const currency = useDisplayCurrency();

  return useQuery(
    favoriteProductsQuery,
    withDisplayCurrency(options, currency)
  );
};

export default useMyFavorites;
